import { useEffect } from "react";
import { useAuth } from "@/lib/auth/context";
import { ensureFcmRegistration } from "@/lib/firebase/messaging";

/**
 * Tryb cichy odświeżania FCM tokena — uruchamia się raz po zalogowaniu jeśli
 * user już dał `Notification.permission === "granted"`. Naprawia główny
 * problem znikających pushy: bez tego stary (zrotowany) token zostaje
 * skasowany przez backend i NIGDY nie zostaje zastąpiony nowym, dopóki
 * user ręcznie nie kliknie "Włącz" / "Odśwież token" w Settings.
 *
 * No-op gdy:
 *  - brak userDoc / householdId (jeszcze nie zalogowany)
 *  - permission != granted (banner / settings ofarują się o to)
 *  - environment bez Notification API (Safari < 16.4 bez PWA install)
 */
export function useFcmAutoRegister(): void {
  const { userDoc, firebaseUser } = useAuth();
  const hid = userDoc?.householdId;
  const uid = firebaseUser?.uid;

  useEffect(() => {
    if (!hid || !uid) return;
    void ensureFcmRegistration(hid, uid);
  }, [hid, uid]);
}
